import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

let echoInstance = null;

/**
 * Returns (or creates) the global Laravel Echo instance.
 * Call this after the user is authenticated so the auth token is available.
 */
export function getEcho() {
  const token = localStorage.getItem('token');
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

  // Re-create when token changes
  if (echoInstance && echoInstance._token === token) {
    return echoInstance;
  }

  if (echoInstance) {
    try { echoInstance.disconnect(); } catch (_) {}
  }

  echoInstance = new Echo({
    broadcaster:   'pusher',
    key:           process.env.REACT_APP_PUSHER_APP_KEY,
    cluster:       process.env.REACT_APP_PUSHER_APP_CLUSTER || 'mt1',
    forceTLS:      true,
    authEndpoint:  `${API_URL}/broadcasting/auth`,
    auth: {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
      },
    },
  });

  echoInstance._token = token;
  return echoInstance;
}

export function disconnectEcho() {
  if (echoInstance) {
    try { echoInstance.disconnect(); } catch (_) {}
    echoInstance = null;
  }
}

export default getEcho;
